import React from "react";
import { Stack, Typography } from "@mui/material";
import { connect } from "react-redux";

import { HubHookFormInput, VendorHookFormSelect } from "../../../components";
import { useHighlightableField } from "../../../hooks";
import { getUserLocation } from "../../../redux";

import { StyledHubCardStack } from "../styles";

const gap = "10px";

const PartThirdParty = ({ location, basePath }) => {
  const { HighlightMenu, getFieldProps } = useHighlightableField();
  const cp = `${basePath}.config`;

  return (
    <StyledHubCardStack gap="25px">
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Third Party Details</Typography>
        <VendorHookFormSelect
          label="Vendor"
          name={`${cp}.vendorId`}
          location={location}
          useDefault
          {...getFieldProps(`${cp}.vendorId`)}
        />
      </Stack>
      <Stack gap={gap}>
        <Typography variant="boldCaptionMain">Third Party Notes</Typography>
        <HubHookFormInput
          name={`${basePath}.notes`}
          label="Special Instructions"
          placeholder="Notes..."
          rows={5}
          multiline
          {...getFieldProps(`${basePath}.notes`)}
        />
      </Stack>
      {HighlightMenu}
    </StyledHubCardStack>
  );
};

const mapStateToProps = (state) => ({
  location: getUserLocation(state),
});

export default connect(mapStateToProps)(PartThirdParty);
